<template>
    <div class="container">
        <div class="simulator-box card-panel">

            <h2 class="simulator-title" :class="{loaded: cliente, 'with-animation' : salvando}">Obrigações financeiras / Dívidas e ônus</h2>

            <div v-if="obrigacoes_financeiras">

                <input-simulador input-type="price" label="Financiamentos" @input="input" v-model="obrigacoes_financeiras.financiamento" />

                <input-simulador input-type="price" label="Financiamento habitacional" @input="input" v-model="obrigacoes_financeiras.financiamento_habitacional" />

                <input-simulador input-type="price" label="Empréstimos" @input="input" v-model="obrigacoes_financeiras.emprestimos" />

                <input-simulador v-show="false" input-type="price" label="Custo de sobrevivência" @input="input" v-model="obrigacoes_financeiras.custo_sobrevivencia" />

                <input-simulador v-show="false" input-type="price" label="CDC" @input="input" v-model="obrigacoes_financeiras.cdc" />

                <input-simulador input-type="price" label="Outros" @input="input" v-model="obrigacoes_financeiras.outros" />

                <total-simulador label="TOTAL" :value="soma" />
            </div>

        </div>

        <footer-simulador :action="concluir" :loading.sync="salvando" />
    </div>
</template>


<script>

import {api} from "@/helpers/api";
import "@/../static/assets/css/custom/flex.css";
import {debounce} from "lodash";

import InputSimulador from '@/components/common/InputSimulador.vue';
import TotalSimulador from '@/components/common/TotalSimulador.vue';
import SvgPercentage from '@/components/common/svg/SvgPercentage.vue';
import FooterSimulador from "@/components/common/FooterSimulador.vue";


export default {

    components: {InputSimulador, SvgPercentage, TotalSimulador, FooterSimulador},
    name: 'obrigacoes_financeiras',

    async created() {

        let {id} = this.$route.params;

        let {data: {result: {data: cliente}}} = await api.get(`cliente/${id}`);

        const obrigacoes_financeiras = {
            financiamento: 0,
            financiamento_habitacional: 0,
            emprestimos: 0,
            custo_sobrevivencia: 0,
            cdc: 0,
            outros: 0,
            ...cliente.obrigacao_financeira,
            cliente_id: cliente.cliente_id
        };

        this.obrigacoes_financeiras = obrigacoes_financeiras;

        this.cliente = cliente;

    },


    computed: {
        soma() {

            let keys = [
                "financiamento",
                "financiamento_habitacional",
                "emprestimos",
                "custo_sobrevivencia",
                "cdc",
                "outros"
            ];

            let total = 0;

            keys.forEach(key => {

                let num =  parseFloat(this.obrigacoes_financeiras[key]);

                total += isNaN(num) ? 0 : num;
            })

            return total;
        },
    },

    data() {
        return {
            cliente: null,
            obrigacoes_financeiras: null,
            salvando: false,

        };
    },

    methods: {

        concluir() {

            if (! this.obrigacoes_financeiras.obrigacao_financeira_id && !this.soma) return;

            this.salvar();
        },

        async salvar() {

            this.salvando = true;


            try{
                await api.put('obrigacoes-financeiras', this.obrigacoes_financeiras);
            } finally {
                setTimeout(() => this.salvando = false, 1000);
            }
        },

        input: debounce(function () {
            this.salvar();
        }, 200)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/clientes/ObrigacoesFinanceiras.vue